import type {
  IActionsFields,
  IHeadingFields,
  ISubheadingFields,
} from '@mentimeter/content-contentful/legacy/types/generated/contentful';

interface DynamicValueProps<V> {
  hasUser: boolean;
  value: V | null;
}

export const getDynamicValueDependingOnUser = <
  V extends IHeadingFields | ISubheadingFields | IActionsFields,
>({
  hasUser,
  value,
}: DynamicValueProps<V>): V['authenticated' | 'unknown'] | undefined => {
  if (!value) return;

  if (hasUser && value.authenticated) {
    return value.authenticated;
  }

  return value.unknown;
};
